import Vue from 'vue'

const state = {
  baseUri: '/botw/hn/contract/'
}
const getters = {
}
const actions = {
  codes: function (_context, [paramData, callback]) { // 검색조건 조회
    const reqData = {
      contractCompSeq: paramData.contractCompSeq
    }
    const axiosOption = {
      method: 'GET',
      url: _context.state.baseUri + 'codes',
      params: reqData
    }
    console.log('actions codes axiosOption : ', axiosOption)
    Vue.axios(axiosOption).then(callback).catch(err => { console.log(err) })
  },
  search: function (_context, [searchParam, callback]) { // 리스트 조회
    const reqData = {
      dongName: searchParam.dongName,
      spotSeq: searchParam.spotSeq,
      contractCompSeq: searchParam.contractCompSeq,
      orderContractCompUserSeq: searchParam.orderContractCompUserSeq,
      contractStateCodeId: searchParam.contractStateCodeId,
      pageNum: searchParam.pageNum,
      rowCount: searchParam.rowCount,
      expireFlag: searchParam.expireFlag
    }
    const axiosOption = {
      method: 'GET',
      url: _context.state.baseUri + 'search',
      params: reqData
    }
    console.log('actions search axiosOption : ', axiosOption)
    Vue.axios(axiosOption).then(callback).catch(err => { console.log(err) })
  },
  detail: function (_context, [contractSeq, callback]) { // 계약정보 상세조회
    const axiosOption = {
      method: 'GET',
      url: _context.state.baseUri + 'detail/' + contractSeq
    }
    console.log('actions search detail : ', axiosOption)
    Vue.axios(axiosOption).then(callback).catch(err => { console.log(err) })
  },
  historyList: function (_context, [spotSeq, callback]) { // 계약정보 이력조회
    const axiosOption = {
      method: 'GET',
      url: _context.state.baseUri + 'historyList/' + spotSeq
    }
    console.log('actions historyList detail : ', axiosOption)
    Vue.axios(axiosOption).then(callback).catch(err => { console.log(err) })
  }
}
const mutations = {
}
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
